import i18n from './../../shared/i18n';
import BaseModel, {defineTranslatableProperties} from "../../core/components/input-widget/BaseModel";
import {Formatter} from "@/core/services/formatter.service";
import SettlementPayment from "@/modules/settlements/SettlementPayment.model";

export default class PaymentModel extends BaseModel {
  uuid = null;
  date = Formatter.getNowAsDate();
  method = null;
  description = null;
  currency_uuid = null;
  settlement_payments = [];
  reference_number = null;
  bank_account = null;
  exchange_rate = null;

  rules = {
    date: 'required',
    method: 'required',
    currency_uuid: 'required',
    bank_account: 'required',
  };

  attributeLabels = {
    date: i18n.t('Date'),
    method: i18n.t('Method'),
    description: i18n.t('Description'),
    reconciled: i18n.t('Reconciled'),
    beneficiary_relation_uuid: i18n.t('Beneficiaries'),
    reference_number: i18n.t('Reference Number'),
    currency_uuid: i18n.t('Currency'),
    bank_account: i18n.t('Bank Account'),
    exchange_rate: i18n.t('Exchange Rate'),
  };

  constructor(data = {}) {
    super();
    Object.assign(this, {...data});
    this.settlement_payments = this.settlement_payments.map(item => new SettlementPayment(item));
    this.initTranslatableFields(this)
  }
}

defineTranslatableProperties(PaymentModel);
